const endpoints = {
  books: '/communication-books',
  adminBooks: '/communication-books/admin',
  allFolios: '/communication-books/folios',
  folios: bookId => `/communication-books/${bookId}/folios`,
  book: bookId => `/communication-books/${bookId}`,
  codes: '/communication-book-codes',
  code: codeId => `/communication-book-codes/${codeId}`,
  codeAssignment: codeId => `/communication-book-codes/${codeId}/assignment`,
  folioFromDraft: bookId => `/communication-books/${bookId}/folios/from-draft`,
  folioOpening: bookId => `/communication-books/${bookId}/folios/opening`,
  folio: folioId => `/communication-folios/${folioId}`,
  pdf: folioId => `/communication-folios/${folioId}/pdf`,
  visibility: folioId => `/communication-folios/${folioId}/visibility`,
  metadata: folioId => `/communication-folios/${folioId}/metadata`,
  description: folioId => `/communication-folios/${folioId}/description`,
  acknowledgement: folioId => `/communication-folios/${folioId}/acknowledgement`,
  acknowledgements: folioId => `/communication-folios/${folioId}/acknowledgements`,
  interactions: folioId => `/communication-folios/${folioId}/interactions`,
  finish: folioId => `/communication-folios/${folioId}/finish`,
}

export default endpoints
